export default "/Collision.glb";